<template lang="html">

  <article class="nota-el -noticia row-center ais">

      <div class="imagen" :style="`background: url(${data.list.url}) center/cover no-repeat;`"></div>

      <div class="contenedor-texto">
          <router-link class="categoria" :to="$t('enlaces.novedades')+'?cat='+data.categoria.slug">{{data.categoria.nombre}}</router-link>
          <h2 class="titulo" :large="data.titulo.length> 50">{{data.titulo}}</h2>
          <p class="descripcion">{{data.entradilla}}</p>
      </div>

      <router-link class="enlace-cover" :to="$t('enlaces.novedades')+'/'+data.slug"></router-link>

  </article>

</template>

<script lang="js">
  export default  {
    name: 'notas-de-prensa',
    props : ['data']
}
</script>




// WEBPACK FOOTER //
// src/components/parts/noticia-el.vue